import { getAlpha2Codes, getName } from 'i18n-iso-countries';
import {
  getCountryCallingCode,
  type CountryCallingCode,
  type CountryCode as CountryCodeType,
} from 'libphonenumber-js';

type CountryCodeProperties = {
  value?: CountryCodeType;
  onChange: (value: CountryCodeType) => void;
  required?: boolean;
  disabled?: boolean;
};

type Country = {
  code: CountryCodeType;
  name: string;
  flag: string;
  callingCode: CountryCallingCode;
};

const UNICODE_FLAG_OFFSET = 127397;

export function CountryCode({
  value,
  onChange,
  required,
  disabled,
}: CountryCodeProperties) {
  const countryList: Country[] = getCountryList();

  return (
    <div className={`form-field${disabled ? ' disabled' : ''}`}>
      <select
        name='countryCode'
        aria-label='Country Calling Code'
        onChange={event => {
          const newCountryCode = event.target.value as CountryCodeType;
          onChange(newCountryCode);
        }}
        className='country-select'
        value={value}
        required={required}
        disabled={disabled}
      >
        {countryList.map(country => {
          return (
            <option
              key={country.code}
              value={country.code}
              style={{ backgroundColor: 'transparent' }}
            >
              {`${country.flag}   ${country.callingCode}`}
            </option>
          );
        })}
      </select>
    </div>
  );
}

function getCountryCodes() {
  return Object.keys(getAlpha2Codes()).map(code =>
    code.toUpperCase()
  ) as CountryCodeType[];
}

function getCountryList() {
  return getCountryCodes()
    .map(code => {
      try {
        const callingCode = getCountryCallingCode(code);
        return {
          code,
          name: getName(code, 'en'),
          flag: getFlagEmoji(code),
          callingCode: `+${callingCode}`,
        };
      } catch {
        return undefined;
      }
    })
    .filter(country => country !== undefined) as Country[];
}

function getFlagEmoji(countryCode: string) {
  return countryCode.replace(/./g, char =>
    String.fromCodePoint(UNICODE_FLAG_OFFSET + char.charCodeAt(0))
  );
}
